import { api } from './client';

// ── Types ──

export interface KwReportJob {
  job_id: string;
  keyword: string;
  status: 'running' | 'completed' | 'failed' | 'pending';
  t1_status: string;
  t2_status: string;
  t3_status: string;
  t4_status: string;
  t5_status: string;
  t6_status: string;
  t7_status: string;
  t8_status: string;
  t1_request_id: string | null;
  t1_started_at: string | null;
  t1_completed_at: string | null;
  t2_started_at: string | null;
  t2_completed_at: string | null;
  t3_started_at: string | null;
  t3_completed_at: string | null;
  created_at: string;
  updated_at: string;
  error_message: string | null;
}

export interface KwReportListItem {
  job_id: string;
  keyword: string;
  status: string;
  t1_status: string;
  t2_status: string;
  t3_status: string;
  t1_request_id: string | null;
  created_at: string;
  updated_at: string;
}

// ── API ──

export const kwReportApi = {
  start: (keyword: string) =>
    api.post<{ job_id: string; keyword: string; status: string }>('/api/kw-report/start', { keyword }),

  status: (jobId: string) =>
    api.get<KwReportJob>(`/api/kw-report/status/${jobId}`),

  list: () =>
    api.get<KwReportListItem[]>('/api/kw-report/list'),
};
